import { render, staticRenderFns } from "./PortalIVA.vue?vue&type=template&id=2f87331a"
import script from "./PortalIVA.vue?vue&type=script&lang=js"
export * from "./PortalIVA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports